import { v4 as uuidv4 } from 'uuid';
import type {
  QueuedTurn,
  QueuedTurnSelection,
} from '../stores/agentForge/types';

/** Builds an immutable snapshot of a browser submission for FIFO dispatch. */
export const createQueuedTurn = (
  text: string,
  displayText: string,
  files: File[],
  selections: QueuedTurnSelection[] = []
): QueuedTurn => ({
  id: uuidv4(),
  text,
  displayText,
  // Snapshot both collections. The composer clears its attachment state as
  // soon as the user submits, and later card clicks must not rewrite what
  // "these" meant for a queued follow-up.
  files: [...files],
  selections: selections.map((selection) => ({
    tool_call_id: selection.tool_call_id,
    ids: [...selection.ids],
  })),
});
